module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tree"
  }, _vm._l((_vm.nodes), function(node) {
    return _c('node', {
      key: node.id,
      attrs: {
        "node": node,
        "TreeModel": _vm.TreeModel,
        "showCounter": _vm.showCounter
      },
      on: {
        "check": _vm.emitCheck
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-1752dee9!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/i-tree/src/tree.vue
// module id = 616
// module chunks = 0